import PluginSelect from './PluginSelect';
import './style/index.less';

export default PluginSelect;
